export default "__VITE_ASSET__9TM5pl3G__"